

const Indicator = ({indColors}) => {
  const squareStyle = {
    height: '2rem',
    width: '2rem',
    marginRight: '1rem',
    border: 'grey 1px solid'
  };

  const squareStyleGreen = {
    ...squareStyle,
    backgroundColor: 'green'
  }

  const squareStyleYellow = {
    ...squareStyle,
    backgroundColor: 'yellow'
  }

  const squareStyleGrey = {
    ...squareStyle,
    backgroundColor: 'lightgrey'
  }


  return (
    <div className="indicators">
      {([...Array(indColors.green)].map((e,i) => (<div key={'green'+i} style={squareStyleGreen}></div>)))}
      {([...Array(indColors.yellow)].map((e,i) => (<div key={'yellow'+i} style={squareStyleYellow}></div>)))}
      {([...Array(4-indColors.green-indColors.yellow)].map((e,i) => (<div key={'grey'+i} style={squareStyleGrey}></div>)))}
    </div>
  )
}

export default Indicator;